import { styled } from "@mui/material/styles";
import { Autocomplete } from "@mui/material";
import {
  APP_COLOR,
  TEXT_COLOR,
} from "../../theme";
export const SelectField = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      height: "100%",
    },
    "&:hover fieldset": {
      borderColor: TEXT_COLOR,
    },
    "&.Mui-focused fieldset": {
      borderColor: APP_COLOR,
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  },
});
